import Registration from '@landingpage/Registration/components/Registration.vue'
import { createApp, defineAsyncComponent, h } from 'vue'
import { createPinia } from 'pinia'
import i18n, { loadPageLocale } from '@landingpage/Common/plugins/i18n'
import CheckoutPage from '@/LandingPage/Checkout/CheckoutPage.vue'
import '../../../../../../resources/css/landingpage/checkout.scss'
import FontAwesomeIcon from '@/Libraries/fontawesome'

// Both inits await the page locale before they mount. The element guard comes first, so a landing
// page without a Vue island never fetches a locale chunk. Alpine awaits the promise x-init returns.
window.initRegistration = async () => {
  const registrationElement = document.getElementById('registrationComponent')
  if (!registrationElement) {
    return
  }

  await loadPageLocale()

  const app = createApp(
    Registration,
    JSON.parse(registrationElement.dataset.props),
  )
  app.use(createPinia())
  app.use(i18n)
  app.mount(registrationElement)
}

window.initCheckoutPage = async () => {
  const checkoutPageElement = document.getElementById('checkout-component')
  if (!checkoutPageElement) {
    return
  }

  await loadPageLocale()

  const app = createApp(
    CheckoutPage,
    JSON.parse(checkoutPageElement.dataset.props),
  )
  app.use(createPinia())
  app.use(i18n)
  app.component('FontAwesomeIcon', FontAwesomeIcon)
  app.mount(checkoutPageElement)
}
